export default __webpack_public_path__ + "static/media/Intro Betty.1bd7a886.mp3";